import axiosPost from '../axiosPost';

export const eventosDeSesionIns = async (arg) => {
    const { nombre, codigo } = arg;

    const body = {
        "service": "EventoDeSesionIns",
        "params": {
            "eventoSesionNombre": nombre,
            "eventoSesionCod": codigo
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};